import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useSeo } from "../components/site/Seo";

export default function LegalPage({ slug }) {
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/legal/${slug}`).then((r) => setP(r.data)).catch(() => setP({ title: "Not available", content: "<p>This page is being updated.</p>" })); }, [slug]);
  useSeo({ title: p ? `${p.title} | Agni Shiksha` : "Agni Shiksha" });
  if (!p) return <div className="container-px py-40 text-center text-content-muted">Loading…</div>;
  return (
    <div className="container-px section-y max-w-3xl">
      <h1 className="font-heading text-3xl font-extrabold tracking-tight mb-6">{p.title}</h1>
      <article className="prose-invert text-content-secondary leading-relaxed [&_p]:mb-4" dangerouslySetInnerHTML={{ __html: p.content }} />
    </div>
  );
}
